import { useAppSelector } from "../redux";
import { usePartnerSessionCanAccessModule } from "./usePartnerSessionPermissions";
import { PARTNER_PORTAL_PERMISSION_KEYS as PP_KEYS } from "../utils/permissions/partnerPortalPermissionKeys";
import { isPartnerTierNotEligible } from "../utils/partnerTierEligibility";

/** Permission + tier eligibility (does not include opt-in consent). */
export function usePartnerProgramBaseEligible(): boolean {
  const partnerTier = useAppSelector(
    (state) => state.partner_details.partnerDetails?.partner_tier
  );
  const partnerProgramConsentEligible = useAppSelector(
    (state) => state.partner_program.partnerProgramConsentEligible
  );
  const partnerProgramAccess = usePartnerSessionCanAccessModule(
    PP_KEYS.PARTNER_PROGRAM_MANAGEMENT
  );

  return (
    partnerProgramAccess &&
    !isPartnerTierNotEligible(partnerTier) &&
    partnerProgramConsentEligible !== false
  );
}

/** Partner portal: permission + tier + active OptIn consent. */
export function useIsPartnerProgramEligible(): boolean {
  const hasBaseEligibility = usePartnerProgramBaseEligible();
  const { consentStatus, consentLoading } = useAppSelector(
    (state) => state.partner_program
  );

  if (!hasBaseEligibility) {
    return false;
  }

  if (consentLoading) {
    return false;
  }

  return consentStatus?.consent_type === "OptIn";
}
